module.exports = __webpack_public_path__ + "img/logo padre color negro.403039af.png";